'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPizza = function IoPizza(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.6 10.2c0.8 0.3 0.9 1 0.7 1.5l-11.5 25.8s-11.2-25-11.6-25.9 0.1-1.2 0.7-1.4c3-1.4 7-2.2 10.8-2.2s7.5 0.7 10.9 2.2z m-15.8 4.8c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1 2.5 2.5 2.5z m5 11.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1 2.5 2.5 2.5z m5-9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1 2.5 2.5 2.5z m7.9-12.3c0.5 0.2 0.8 0.4 0.8 1 0 0.1 0 0.2-0.1 0.4l-0.6 1.4c-0.2 0.4-0.6 0.8-1.1 0.8-0.1 0-0.2-0.1-0.5-0.2-3.2-1.4-7.4-2.3-11.5-2.3s-7.9 0.8-11.4 2.3c-0.3 0.1-0.3 0.2-0.5 0.2-0.5 0-0.9-0.4-1.1-0.8l-0.6-1.4s-0.1-0.2-0.1-0.4c0-0.7 0.5-1 0.8-1.1 3.8-1.7 8.3-2.6 13-2.6s9.2 1 12.9 2.7z' })
        )
    );
};

exports.default = IoPizza;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pizza.js
// module id = 2380
// module chunks = 0